import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PollSingleAbstract } from '../../../../../abstracts/poll-single.abstract';
import { FormGroup } from '@angular/forms';
import { ToastController } from 'ionic-angular';
import { IClientConfig } from '../../../../../models/client.model';
import { has } from 'lodash';
import { UtilitiesProvider } from '../../../../../providers/utilities';
@Component({
  selector: 'app-event-open-question',
  templateUrl: 'event-open-question.html'
})

export class EventOpenQuestionComponent extends PollSingleAbstract implements OnInit, OnChanges {

  @Input('clientConfig')
  public clientConfig: IClientConfig;

  public form: FormGroup;

  @Input()
  public questionId: string;

  @Input('userAnswer')
  public userAnswer: any;

  @Input()
  public language: string;

  @Input('lastQuestion')
  public lastQuestion: boolean;

  @Input('userHasRecord')
  public userHasRecord: boolean;

  constructor(
    public toastCtrl: ToastController,
    private utilitiesData: UtilitiesProvider
  ) {
    super(toastCtrl);
  }

  ngOnInit() {
    this.buildForm();
    this.checkAnswers();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (has(changes, 'questionId') && changes.questionId.firstChange === false) {
      this.form.reset();
      this.patchForm({ id: this.questionId });
      this.utilitiesData.consoleWarn('Change Question Id', this.questionId);
    }
    if (has(changes, 'userAnswer') && changes.userAnswer.firstChange === false) {
      this.form.reset();
      this.patchForm({ id: this.questionId, value: this.userAnswer });
      this.utilitiesData.consoleWarn('Change User Answer', this.userAnswer);
    }
  }

  public checkAnswers() {
    if (this.userAnswer) {
      this.patchForm({ id: this.questionId, value: this.userAnswer });
    } else {
      this.patchForm({ id: this.questionId });
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/poll-event/components/event-poll-questions/event-open-question/event-open-question.ts